import { last } from 'lodash-es'

import envRaw from './env-raw'
import Emitter from './emitter'
import debugFields from './debug-fields'

import { onEventPassive } from './on-event'

export default entryEmitterProvider()

function entryEmitterProvider() {
  const entryRE = /Entry=(\d+)/
  const entryEmitter = Emitter('entry')
  onEventPassive(window, 'message', handler)

  return debugFields(entryEmitter, {
    _handler: handler
  })

  function handler({ data }) {
    if (!entryRE.test(data)) {
      return
    }

    const entryMethodId = parseInt(last(entryRE.exec(data)))
    entryEmitter.emit(entryMethodId)

    if (envRaw.showsEntryEmitterDebug) {
      console.debug(`${Date.now()} !entryEmitter: { entryMethodId: ${entryMethodId} }`)
    }
  }
}
